import {
  LOADED_DELAY_CERTIFICATES,
} from '../actions'

const initialState = {
  delayCertificates: null,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADED_DELAY_CERTIFICATES:
      return {
        ...state,
        delayCertificates: action.delayCertificates,
      }
    default:
      return state
  }
}

export default reducer